// extracted by mini-css-extract-plugin
export default {"title":"l5-z","warning":"m5-z","sizeOptionsLegendText":"n5-z"};